export default "__VITE_ASSET__BIxGc8jF__"